<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="数据最大容量" prop="maxsize">
          <el-input-number v-model="form.maxsize"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="轮训间隔" prop="listidle">
          <el-input v-model="form.listidle"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限定扩展名" prop="speexts">
          <el-input v-model="form.speexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限制扩展名" prop="excexts">
          <el-input v-model="form.excexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
  import rApi from "@/api/senior/seniorconf";
let datafault = {
};
export default {
  components: { rApi },
  props: {
    uuid:""
  },
  data() {
    return {
      form:{
        maxsize:4194304,
        listidle:"10,30",
        speexts:"",
        excexts:"",
        threshold:2000,
      }
    };
  },
  mounted() {
    if(this.uuid){
      rApi.getCsSenior(this.uuid).then(resp=>{
        var _form = JSON.parse(resp.data);
        this.form.listidle = _form.listidle?_form.listidle:this.form.listidle;
        this.form.speexts = _form.speexts?_form.speexts:this.form.speexts;
        this.form.excexts = _form.excexts?_form.excexts:this.form.excexts;
        this.form.maxsize = _form.maxsize?_form.maxsize:this.form.maxsize;
        this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
      });
    }
  },
  methods: {
    save(){
      if(this.uuid){
        rApi.doSaveForCsSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
      }
      return this.form;
    }
  }
};
</script>
<style scoped>
</style>